import React from "react";
import 'chart.js/auto';
import { Chart } from 'react-chartjs-2';

export default function BarChartTotal() {
  const labels = ["ม.ค.", "ก.พ.", "มี.ค." , "เม.ย." , "พ.ค." , "มิ.ย." , "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.","พ.ย.","ธ.ค." ];

const dataNew = {
    labels,
    datasets: [
      {
        type: 'bar' ,
        label: 'จำนวนคนมาโรงเรียน',
        backgroundColor: "#BAB2F4",
        data: [98, 95, 98, 96, 97, 99, 96, 95, 95, 94, 97, 96],
        borderColor: 'white',
        barPercentage: 0.3,
        borderSkipped: false,
        borderRadius: Number.MAX_VALUE,
      },
      {
        type: 'bar' ,
        label: 'ลาป่วย',
        backgroundColor: "#EFB2F4",
        data: [2, 3, 4, 1, 2, 3, 5, 4, 4, 4, 3, 4],
        barPercentage: 0.3,
        borderSkipped: false,
        borderRadius: Number.MAX_VALUE,
      },
      {
        type: 'bar' ,
        label: 'ลาอื่นๆ',
        backgroundColor: "#FF8484",
        data: [4, 1, 2, 1, 0, 0, 5, 4, 1, 3, 2, 1],
        barPercentage: 0.3,
        borderSkipped: false,
        borderRadius: Number.MAX_VALUE,
      },
    ],
  };

  const data = {
    labels,
    datasets: [
      {
        label: "จำนวนคนอุณหภูมิปกติ",
        data: [10, 20, 30, 40, 50, 50, 30, 10, 15, 12, 11, 30],
        backgroundColor: "rgba(186, 178, 244, 1)",
        borderRadius: {
          topLeft: Number.MAX_VALUE,
          topRight: Number.MAX_VALUE,
          bottomLeft: Number.MAX_VALUE,
          bottomRight: Number.MAX_VALUE,
        },
        barPercentage: 0.3,
        borderSkipped: "false",
      },
      {
        label: "จำนวนคนอุณหภูมิสูง",
        data: [2, 3, 9, 1, 2, 3, 5, 7, 9, 4, 3, 8],
        backgroundColor: "rgba(255, 132, 132, 0.5)",
        borderRadius: Number.MAX_VALUE,
        barPercentage: 0.3,
        borderSkipped: "false",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        align: "end",
      },
      title: {
        display: false,
        text: "Chart.js Bar Chart",
        align: "center",
      },
    },
    scales: {
      x: {
        grid: {
          display: false
        }
      },
      y: {
        grid: {
          display: false
        }
      }
    }
  };

  return <Chart style={{ height: "400px", maxHeight:'400px' }} options={options} data={dataNew} />;
}
